import instance from "@/utils/require.js"

// 销售订单--分页查询
export function apiCustomerOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/customer_order/search",
		method: "post",
		data
	})
}

// 销售订单--查询条件--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 销售订单--查询条件--产品类别
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 销售订单--查询条件--产品型号
export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

// 销售订单--查询条件--订单状态
export function apiOrderStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/order_status",
		method: "post",
		data
	})
}

// 销售订单--创建销售订单
export function apiCustomerOrderAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/customer_order/add",
		method: "post",
		data
	})
}


// 销售订单--添加组装工单
export function apiAddProductionOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/customer_order/addProductionOrder",
		method: "post",
		data
	})
}

// 销售订单
export function apiCustomerOrderUpdateOrderNumber(data = {}) {
	return instance({
		url: "/aim/api/v3/customer_order/update_order_number",
		method: "post",
		data
	})
}
// 销售订单--销售订单详情
export function apiCustomerOrderDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/customer_order/detail",
		method: "post",
		data
	})
}

// 销售订单--修改销售订单
export function apiCustomerOrderUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/customer_order/update",
		method: "post",
		data
	})
}